import { render, staticRenderFns } from "./ai-assistant.vue?vue&type=template&id=cadc2b68&"
import script from "./ai-assistant.vue?vue&type=script&lang=js&"
export * from "./ai-assistant.vue?vue&type=script&lang=js&"
import style0 from "./ai-assistant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports